import React from "react";
import { Pagination as BootstrapPagination } from "react-bootstrap";
import "./styles.css";

function Pagination(props) {
    const { currentPage, itemsPerPage, totalItems, onPageChange } = props;

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    const pageItems = [];
    let start = Math.max(currentPage - 2, 1);
    let end = Math.min(start + 4, pageNumbers.length);

    if (currentPage > 3) {
        pageItems.push(
        <BootstrapPagination.First key="first" onClick={() => onPageChange(1)} />
        );
        pageItems.push(
        <BootstrapPagination.Prev
            key="prev"
            onClick={() => onPageChange(currentPage - 1)}
        />
        );
    }

    for (let i = start; i <= end; i++) {
        pageItems.push(
        <BootstrapPagination.Item
            key={i}
            className={i === currentPage ? "active" : ""}
            onClick={() => onPageChange(i)}
        >
            {i}
        </BootstrapPagination.Item>
        );
    }

    if (currentPage < pageNumbers.length - 2) {
        pageItems.push(
        <BootstrapPagination.Next
            key="next"
            onClick={() => onPageChange(currentPage + 1)}
        />
        );
        pageItems.push(
        <BootstrapPagination.Last
            key="last"
            onClick={() => onPageChange(pageNumbers.length)}
        />
        );
    }

    return (
        <BootstrapPagination className="custom-pagination">
        {pageItems}
        </BootstrapPagination>
    );
}

export default Pagination;
